export const a11y = {
    getAltTextSpinner: (a11yDescription) => `Loading ${a11yDescription} results`,
    getAriaLiveSelection: (option) => `${option} selected`,
    getAriaLiveResults: (optionsLength) => `${optionsLength} result${optionsLength === 1 ? '' : 's'} available.${optionsLength > 0 ? ' Use up and down arrows to select.' : ''}`,
    ariaLabelShowPassword: 'show password',
    ariaLabelHidePassword: 'hide password',
    ariaLabelShowResults: 'show results',
    ariaLivePasswordHidden: 'Your password is hidden',
    getAriaLivePasswordVisible: (inputValue) => `Your password is ${inputValue}`,
};
export const visual = {
    noResults: 'No results available',
};
//# sourceMappingURL=strings.js.map